export default __webpack_public_path__ + "static/media/kitchen3-afterJ-768w.6610dc9d.avif";